"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = purchasedGoodReducer;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _immutable = require("immutable");

var _ActionTypes = _interopRequireDefault(require("../constants/ActionTypes"));

var _DetailsPanelItems = _interopRequireDefault(require("../constants/DetailsPanelItems"));

var _utils = require("../utils/managePurchases/utils");

function purchasedGoodReducer(purchasedGood, action) {
  switch (action.type) {
    case _ActionTypes.default.GOOD_USAGE_INFO_RECEIVED:
      return purchasedGood.merge({
        assetsWhereGoodInUse: (0, _immutable.fromJS)(action.payload.assetsWhereGoodInUse)
      });

    case _ActionTypes.default.REVIEW_SUBMITTED_FROM_PURCHASES_SUCCESS:
      return purchasedGood.merge((0, _defineProperty2.default)({}, _DetailsPanelItems.default.REVIEW, action.payload.review));

    case _ActionTypes.default.TOGGLE_PURCHASED_PACK:
      return purchasedGood.merge({
        showChildren: !purchasedGood.get('showChildren')
      });

    case _ActionTypes.default.POLLING_GOOD_INFO_RECEIVED:
      {
        var goodDeliverInfo = action.payload.goodDeliverInfo;

        if (purchasedGood.get('parentId')) {
          var child = purchasedGood.toJS();
          return purchasedGood.merge({
            destinationId: (0, _utils.getChildDestinationId)(goodDeliverInfo, child),
            templatePath: (0, _utils.getChildTemplatePath)(goodDeliverInfo, child)
          });
        }

        return purchasedGood.merge({
          destinationId: (0, _utils.getDestinationIdForGoodNotInPack)(goodDeliverInfo),
          newVersionAvailable: false,
          templatePath: (0, _utils.getTemplatePathForGoodNotInPack)(goodDeliverInfo)
        });
      }

    default:
      return purchasedGood;
  }
}

module.exports = exports.default;